module.exports = __webpack_public_path__ + "media/flags/de-e5b6eff3.svg";